import { render, staticRenderFns } from "./the-frame.vue?vue&type=template&id=2721d8a2"
import script from "./the-frame.vue?vue&type=script&lang=js"
export * from "./the-frame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports